<template>
  <div class="task_logs">
    <div class="public-breadcrumb">
      <router-link style="color: #6e6b7b" to="/">{{
        $t("devices.Welcome")
      }}</router-link>
      > {{ $t("lcd.Devices.DevicesManage") }} >
      <span style="color: #3461ff">{{ $t("lcd.Devices.Devices logs") }}</span>
    </div>
    <div class="table_set">
      <div class="select_filter flex-between">
        <div>
          <span class="text"
            >{{ $t("taskLog.Records") }}:{{ pageParams.total }}</span
          >
          <el-select
            v-model="pageParams.storeType"
            @change="getDeviceLogs"
            size="small"
          >
            <el-option
              v-for="item in storeQueryTypeList"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            />
          </el-select>
        </div>
        <div>
          <button class="refresh" @click="handleRefresh" ref="btn">
            <i class="el-icon-refresh"></i>
          </button>
        </div>
      </div>
      <el-table
        ref="tableRows"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        class="table-topstyle"
        v-loading="tableLoading"
        @select-all="handleSelectAll"
        @sort-change="handleSortChange"
      >
        <el-table-column type="selection" width="55">
          <el-table-column type="selection" />
        </el-table-column>
        <el-table-column :label="$t('taskLog.Store Name')">
          <el-table-column prop="storeName" min-width="150">
            <template slot="header">
              <el-input
                clearable
                v-model="pageParams.storeName"
                size="mini"
                @input="getDeviceLogs"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="$t('lcd.Devices.Task ID')"
          prop="taskId"
          align="left"
        >
          <el-table-column prop="taskId" min-width="180">
            <template slot="header">
              <el-input
                clearable
                v-model="pageParams.taskId"
                size="mini"
                @input="getDeviceLogs"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="$t('lcd.Devices.Device ID')"
          prop="screenCode"
          align="left"
        >
          <el-table-column prop="screenCode" min-width="180">
            <template slot="header">
              <el-input
                clearable
                v-model="pageParams.screenCode"
                size="mini"
                @input="getDeviceLogs"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('taskLog.Task Type')">
          <el-table-column prop="taskTypeId" min-width="150">
            <template slot="header">
              <el-select
                v-model="pageParams.taskTypeId"
                size="mini"
                placeholder=""
                clearable
                @change="getDeviceLogs"
              >
                <el-option
                  v-for="item in taskTypeList"
                  :key="item.codeId"
                  :label="item.codeName"
                  :value="item.codeId"
                />
              </el-select>
            </template>
            <template slot-scope="scope">
              <span class="table-cell__task-type">
                <span class="table-cell__task-type-name">{{
                  scope.row.taskTypeDesc
                }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('taskLog.Status')">
          <el-table-column prop="taskStateDesc" width="150">
            <template #header>
              <el-select
                v-model="pageParams.taskState"
                placeholder=""
                size="mini"
                clearable
                @change="getDeviceLogs"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.codeId"
                  :label="item.codeName"
                  :value="item.codeId"
                />
              </el-select>
            </template>
            <template slot-scope="scope">
              <el-tag type="danger" v-if="scope.row.taskState == '4601'">{{
                scope.row.taskStateDesc
              }}</el-tag>
              <el-tag v-if="scope.row.taskState == '4602'">{{
                scope.row.taskStateDesc
              }}</el-tag>
              <el-tag type="warning" v-if="scope.row.taskState == '4603'">{{
                scope.row.taskStateDesc
              }}</el-tag>
              <el-tag type="info" v-if="scope.row.taskState == '4604'">{{
                scope.row.taskStateDesc
              }}</el-tag>
              <el-tag type="success" v-if="scope.row.taskState == '4605'">{{
                scope.row.taskStateDesc
              }}</el-tag>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('lcd.Devices.Oprate Result')">
          <el-table-column prop="taskResultDesc" width="150">
            <template #header> </template>
          </el-table-column>
        </el-table-column>

        <el-table-column :label="$t('taskLog.Begin time')" prop="startTime">
          <el-table-column prop="startTime" min-width="220">
            <template #header> </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('taskLog.End time')" prop="endTime">
          <el-table-column prop="endTime" min-width="220">
            <template #header> </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="$t('taskLog.Create Time')"
          prop="createTime"
        >
          <el-table-column prop="createTime" min-width="220">
            <template #header>
              <!-- <el-date-picker
                clearable
                v-model="pageParams.createTime"
                type="daterange"
                align="center"
                size="mini"
                class="intergation_picker"
                unlink-panels
                range-separator="-"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                @change="getDeviceLogs"
              /> -->
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="$t('taskLog.Action')"
          prop="processeds"
          fixed="right"
        >
          <el-table-column prop="processeds" width="100">
            <template #header></template>
            <template slot-scope="scope">
              <el-button
                style="color: #35b871; font-size: 12px"
                type="text"
                icon="el-icon-detail"
                @click="handleDetail(scope.row)"
                >{{ $t("lcd.Devices.Detail") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <pagination :tableInfo="pageParams" @changePage="changePage" />

      <task-detail
        :dialogVisible="dialogVisible"
        :previewObj="taskDetail"
        @handleClose="handleClose"
      ></task-detail>
    </div>
  </div>
</template>
<script>
import { commonStore } from "@/store/global-select-store";
import modelUi from "@/views/taskManagement/taskManger/utils/modelUi.js";
import { getCodeList } from "@/libs/api/taskManger.js";
import {
  parseResp,
  parseError,
} from "@/views/taskManagement/taskManger/utils/requestUtil.js";
import { getStoreId } from "@/views/taskManagement/taskManger/utils/cacheUtil.js";
import pagination from "@/components/pagination";
import { screenTaskList, screenTaskDetail } from "@/libs/api/lcd";
import TaskDetail from "./components/details";

export default {
  components: {
    TaskDetail,
    pagination,
  },
  data() {
    return {
      dialogVisible: false,
      taskDetail: {},
      commonStore,
      stateList: [],
      taskTypeList: [],
      storeQueryTypeList: [
        {
          dictValue: 2,
          dictName: this.$t("ThisStore"),
        },
        {
          dictValue: 1,
          dictName: this.$t("ZimenStore"),
        },
        {
          dictValue: 0,
          dictName: this.$t("AllStore"),
        },
      ],
      leng: "",
      tableData: [],
      pageParams: {
        current: 1,
        size: 10,
        total: 0,
        storeType: 2,
        storeName: "",
        screenCode: "", // lcd屏sn
        taskTypeId: "",
        taskState: "",
        startDate: null,
        endDate: null,
        orders: [],
        result: "",
      },
      tableLoading: false,
    };
  },

  created() {
    commonStore.setInjectCallBack(this.initPage);
    this.initPage();
  },
  computed: {
    language() {
      return this.$store.state.appConfig.language;
    },
  },
  watch: {
    language(val) {
      if (val) this.initPage();
    },
  },
  methods: {
    handleRefresh() {
      this.tableLoading = true;
      this.getDeviceLogs();
    },
    initPage() {
      this.getDeviceLogs();
      this.getStateListReq();
      this.getTaskTypeListReq();
    },
    changePage() {
      this.getDeviceLogs();
    },
    handleSortChange(v1) {
      const { prop } = v1;
      const { order } = v1;
      let orderStr = "";
      if (order === "descending") {
        orderStr = "desc";
      }
      if (order === "ascending") {
        orderStr = "asc";
      }

      let keyName = "";
      if (prop === "taskName") {
        keyName = "task_name";
      }
      if (prop === "startDate") {
        keyName = "start_date";
      }
      if (prop === "endDate") {
        keyName = "end_date";
      }
      if (prop === "duration") {
        keyName = "duration";
      }
      if (prop === "errors") {
        keyName = "errors";
      }
      if (prop === "processeds") {
        keyName = "processeds";
      }

      if (orderStr) {
        const orders = [];
        const orderItem = `${orderStr}:${keyName}`;
        orders.push(orderItem);
        this.pageParams.orders = orders;
      } else {
        this.pageParams.orders = [];
      }
      this.getDeviceLogs();
    },

    getStateListReq() {
      getCodeList(46)
        .then((res) => {
          const result = parseResp(res);
          if (result.success) {
            this.stateList = result.data;
          } else {
            modelUi.msgError(result.message);
          }
        })
        .catch((err) => {
          modelUi.msgError(parseError(err));
        });
    },

    getTaskTypeListReq() {
      getCodeList(45)
        .then((res) => {
          const result = parseResp(res);
          if (result.success) {
            let typeList = result.data;
            // typeList = typeList.filter(
            //   (item) => item.codeHelp === "taskSchedule"
            // );
            console.log("typeList", typeList);
            this.taskTypeList = typeList;
          } else {
            modelUi.msgError(result.message);
          }
        })
        .catch((err) => {
          modelUi.msgError(parseError(err));
        });
    },

    selection() {
      return this.$refs.tableRows && this.$refs.tableRows.selection.length;
    },
    handleSelectAll() {
      const { isAllSelected } = this.$refs.tableRows.store.states;
      console.log(
        "selection==",
        this.$refs.tableRows.store.states.isAllSelected
      );
      if (isAllSelected) {
        const arr = [];
        selection.forEach((it) => {
          arr.push(...it.children);
        });
        this.selectChild(arr);
      } else {
        this.$refs.tableRows.clearSelection();
      }
    },
    // 获取列表数据
    getDeviceLogs() {
      this.tableLoading = true;
      const {
        current,
        size,
        screenCode,
        storeType,
        storeName,
        taskName,
        taskTypeId,
        taskState,
        startTime,
        endTime,
        orders,
      } = this.pageParams;

      const params = {
        current,
        size,
        screenCode,
        storeType,
        storeName,
        taskName,
        taskTypeId,
        taskState,
        startTime,
        endTime,
        orders,
        storeId: getStoreId(),
      };

      screenTaskList(params).then((res) => {
        console.log(res);
        this.tableLoading = false;
        this.pageParams.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },

    // 查询错误
    quertError(rows) {
      console.log("任务日志---查询失败数", rows);
      // const { message } = rows;
      rows.type = "task";
      this.$refs.errorsLogDialogRef.openDialog(rows);
    },

    handleDetail(row) {
      console.log(row);
      const params = {
        taskId: row.taskId,
      };
      screenTaskDetail(params).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 1) {
          this.taskDetail = res.data.data;
          this.dialogVisible = true;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.taskDetail = {};
    },
  },
};
</script>

<style lang="scss" scoped>
// .storelistrom {
// padding: 0 10px 10px;
// }
.task_logs {
  .txtalein {
    padding-bottom: 20px;
    color: #000;
    font-size: 12px;
  }
  .table-cell__task-type {
    background-color: #f1f1f1;
    border-radius: 14px;
    padding: 2px 16px;
    display: inline-block;
  }

  .table-cell__task-type-icon {
    width: 16px;
    height: 16px;
  }

  .table-cell__task-type-name {
    color: #555555;
    font-size: 14px;
    margin-left: 5px;
  }
  .integration_link {
    color: #000 !important;
    border-radius: 20px;
  }
  .integation_serch {
    margin-left: 10px;
    cursor: pointer;
  }
  .integation_serch:hover {
    color: brown;
  }
  .intergation_picker {
    width: 200px;
  }
}
.icon {
  padding: 6px;
  cursor: pointer;
  .svg-icon {
    width: 23px;
    height: 23px;
  }
}

.text {
  padding: 0 15px;
  font-size: 12px;
}
.table_set {
  border-radius: 6px;
  padding: 15px 0 0;
  background-color: white;
  .select_filter {
    padding-bottom: 15px;
    .table_label_size {
      width: 160px;
      font-size: 16px;
    }
    .table_select {
      width: 214px;
    }
  }
  .icon {
    padding: 6px;
    cursor: pointer;
    .svg-icon {
      width: 23px;
      height: 23px;
    }
  }
  .tb_checkbox {
    vertical-align: middle;
  }
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.refresh {
  background: #35b871;
  border: none;
  padding: 7px 9px;
  border-radius: 4px;
  color: #fff;
  margin-right: 15px;
}
</style>
